import {
  EVENTS_REQUEST,
  EVENTS_SUCCESS,
  EVENTS_FAILURE,

  EVENT_CHANGE,
  EVENT_CHANGE_ALL,
} from '../../actions/events';

import {
  WS_EVENT_NEW,
  WS_EVENT_STATUS,
} from '../../actions/websockets';

import unread from './unread';

export { unread };

const defaultState = {
  result: 'none',
  id: null,
  count: 0,
  offset: 0,
  loading: false,
  events: [],
};

export function events(state = defaultState, action) {
  switch (action.type) {

    case EVENTS_REQUEST: {
      return { ...state, loading: true };
    }

    case EVENTS_SUCCESS: {
      return { ...defaultState, ...action.payload };
    }

    case EVENTS_FAILURE: {
      return { ...state, loading: false };
    }

    case EVENT_CHANGE: {
      return {
        ...state,
        events: state.events.map(event => (
          event.id === action.payload.id
          ? { ...event, ...action.payload }
          : event
        )),
      };
    }

    case EVENT_CHANGE_ALL: {
      return {
        ...state,
        events: state.events.map(event =>
          ({ ...event, ...action.payload.status })
        ),
      };
    }

    default:
  }

  // если не получали данные событий, вебсокет игнорируем
  if (state.result !== 'success') return state;

  // добавление нового события из websokets
  if (action.type === WS_EVENT_NEW
    && !state.offset
    && ((!state.id && action.payload.account_event) || state.id === action.payload.subject_id)
  ) {
    return {
      ...state,
      count: state.count + 1,
      events: [action.payload, ...state.events.slice(0, -1)],
    };
  }

  // измнение статуса события из websokets
  if (action.type === WS_EVENT_STATUS
    && ((!state.id && action.payload.account_event) || state.id === action.payload.subject_id)
  ) {
    return {
      ...state,
      events: state.events.map(event => (
        action.payload.id === event.id ? action.payload : event
      )),
    };
  }

  return state;
}
